import { useState } from "react"
import styles from "./PatientDetailsTableHeadCellCard.module.css"
import ArrowUpIcon from "@assets/icons/arrowUp"
const PatientDetailsTableHeadCellCard = ({
  name,
  setShowFilters,
  setFilterToBeExpanded,
  setPaginationState,
  sortPath,
}) => {
  const [showDropDown, setShowDropDown] = useState(false)

  const handleSorting = (event) => {
    if (setPaginationState) {
      const order = event.currentTarget.value
      setPaginationState((previous) => {
        return { ...previous, sortBy: sortPath, order, page: 1 }
      })
    }
  }

  return (
    <div
      className={styles.tableHeadWrapper}
      onClick={() => {
        setShowDropDown((previous) => {
          return !previous
        })
      }}
    >
      {name}
      {name !== "Plan" ? (
        <ArrowUpIcon className="text-[--primary-blue]" />
      ) : null}
      {showDropDown && name !== "Plan" ? (
        <div className={styles.filterDropdown}>
          <button value="1" className={styles.option} onClick={handleSorting}>
            A - Z
          </button>
          <button value="-1" className={styles.option} onClick={handleSorting}>
            Z - A
          </button>
          <div
            className={styles.option}
            data-name={name}
            onClick={(event) => {
              const filterName = event.currentTarget.getAttribute("data-name")
              setFilterToBeExpanded(filterName)
              setShowFilters(true)
            }}
          >
            Filter by
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default PatientDetailsTableHeadCellCard
